import React from 'react';
import styles from './VendorDeviceList.module.css';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import allGreen from 'routes/vendorRe/images/all_green.png';
import allError from 'routes/vendorRe/images/all_error.png';
import {
    commonGap,
    contentCenter,
    contentStart,
    deviceEm,
    error,
    errorManegement,
    infoEm,
    infoFontSize1,
    infoFontSize2,
    infoHeight,
    spaceAround,
    success,
    systemEnd,
    systemStart,

} from 'routes/vendorRe/constraint/constraints';
import { decode } from 'shared/utils/Utils';

const VendorDeviceList = (props) => {
    const { data, storeName } = props;
    return (
        <FlexChild backgroundColor="#fff" borderRadius={infoEm} marginBottom={deviceEm} height={infoHeight} padding={deviceEm}>
            <VerticalFlex gap={commonGap}>
                <FlexChild>
                    <HorizontalFlex>
                        <FlexChild flex="1">
                            <div className={styles.deviceThumb1}>
                                {
                                    data && data.image != null ?
                                        <img src={`data:image/png;base64,${data.image}`} style={{ height: "100px" }} />
                                        :
                                        <P size={"4.1vw"}>머신</P>
                                }
                            </div>
                        </FlexChild>
                        <FlexChild flex="10" padding="0 1.8em">
                            <VerticalFlex justifyContent={spaceAround} height="150px">
                                <FlexChild justifyContent={contentCenter} alignItems={contentStart}>
                                    {
                                        data && data.image != null ?
                                            <P size={"4.1vw"}>{storeName && storeName} 키오스크</P>
                                            :
                                            <P size={"4.1vw"}>{storeName && storeName} {data && data.vendingName}</P>
                                    }

                                </FlexChild>
                                <FlexChild justifyContent={contentCenter} alignItems={contentStart}>
                                    {/* 
                                        정상인지 오류인지에 따라서 변하는 구간 

                                        1. 정상인 경우
                                        <P size={infoFontSize1}>
                                            <img className={styles.status} src={allGreen} alt={success} />
                                            <span style={{marginLeft: infoEm}}>{success}</span>
                                        </P>

                                        2. 에러인 경우
                                        <P size={infoFontSize1}>
                                            <img className={styles.status} src={allError} alt={error} />
                                            <span style={{marginLeft: infoEm}}>{error}</span>
                                        </P>
                                    */}
                                    {
                                        data && data.heartbeat != null
                                            ?
                                            <P size={infoFontSize1}>
                                                <img className={styles.status} src={allGreen} alt={success} />
                                                <span style={{ marginLeft: infoEm }}>{success}</span>
                                            </P>
                                            :
                                            <P size={infoFontSize1}>
                                                <img className={styles.status} src={allError} alt={error} />
                                                <span style={{ marginLeft: infoEm }}>{error}</span>
                                            </P>
                                    }
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <HorizontalFlex gap={commonGap}>
                        <FlexChild>
                            <div className={styles.sysCloseBtn}>
                                <P size={"min(2vw, 14px)"}>{systemEnd}</P>
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <div className={styles.button}>
                                <P size={"min(2vw, 14px)"}>
                                    {systemStart}
                                </P>
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <div className={styles.button}>
                                <P size={"min(2vw, 14px)"}>
                                    {errorManegement}
                                </P>
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </VerticalFlex>
        </FlexChild>
    );
};

export default VendorDeviceList;